<div fxLayout="column" class="background" fxLayoutAlign="start center">
  <div fxFlex="75">
    <!-- Título -->
    <section id="header">
      <h1 class="h1Header">{{ isEditMode ? 'EDITAR TURNO - PUNTO FIJO' : 'VER TURNO - PUNTO FIJO' }}</h1>
    </section>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner></mat-spinner>
    </div>

    <!-- Formulario de detalles -->
    <mat-card *ngIf="!isLoading && session" class="form-card">
      <mat-card-content>
        <form class="session-form">
          
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>ID del Turno</mat-label>
            <input matInput [value]="session.id" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cadete</mat-label>
            <mat-select
              [(ngModel)]="session.cdDelivery"
              name="cdDelivery"
              [disabled]="isEditMode || !!session.endTime">
              <mat-option *ngFor="let cadete of cadetes" [value]="cadete.cdDelivery">
                {{ cadete.dsName }} ({{ cadete.dsPhone }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre del Cadete</mat-label>
            <input matInput [value]="session.deliveryName" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Teléfono del Cadete</mat-label>
            <input matInput [value]="session.deliveryPhone" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Hora de Inicio</mat-label>
            <input matInput [value]="formatUtcToArgentina(session.startTime)" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Hora de Fin</mat-label>
            <input matInput [value]="formatUtcToArgentina(session.endTime)" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Horas Trabajadas</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="session.hours"
              name="hours"
              step="0.1"
              placeholder="Ej: 8.5"
              [disabled]="!session.endTime">
            <mat-hint>Horas trabajadas (editable)</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cliente</mat-label>
            <input
              matInput
              [(ngModel)]="session.client"
              name="client"
              placeholder="Buscar o ingresar nombre"
              [matAutocomplete]="clientAutoComplete"
              (input)="filterClients($event)"
              (blur)="onClientInput()"
            />
            <mat-autocomplete #clientAutoComplete="matAutocomplete" (optionSelected)="onClientSelected($event.option.value)">
              <mat-option *ngFor="let client of filteredClients" [value]="client">
                {{ client.dsNombreFantasia || client.dsRazonSocial }} - CUIT: {{ client.dsCUIT }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint>Información del cliente o comercio</mat-hint>
          </mat-form-field>

          <div class="status-badge" [ngClass]="session.endTime ? 'finished' : 'in-progress'">
            <mat-icon>{{ session.endTime ? 'check_circle' : 'schedule' }}</mat-icon>
            <span>{{ session.endTime ? 'Finalizado' : 'En curso' }}</span>
          </div>

        </form>
      </mat-card-content>
    </mat-card>

    <!-- Botones de acción -->
    <div *ngIf="!isLoading && session" class="action-buttons">
      <button mat-raised-button (click)="onCancel()">
        <mat-icon>arrow_back</mat-icon>
        Volver
      </button>

      <button 
        mat-raised-button 
        color="warn" 
        *ngIf="!session.endTime"
        (click)="onEndShift()">
        <mat-icon>stop</mat-icon>
        Finalizar turno
      </button>

      <button 
        mat-raised-button 
        color="primary" 
        *ngIf="isEditMode"
        (click)="onSave()">
        <mat-icon>save</mat-icon>
        Guardar cambios
      </button>
    </div>

    <!-- Mensaje de error -->
    <mat-card *ngIf="!isLoading && !session" class="error-card">
      <mat-card-content>
        <p>No se pudo cargar el turno</p>
        <button mat-raised-button color="primary" (click)="onCancel()">
          Volver al listado
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
